import React from "react";
import "./SkeletonLoader.scss";
import ClassNames from "classnames";

export interface SkeletonLoaderProps {
  width?: string;
  height?: string;
  isBlue?: boolean;
  wrapperClassName?: string;
  className?: string;
  "data-testid"?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = (props) => {
  const {
    width,
    height,
    isBlue,
    wrapperClassName,
    "data-testid": dataTestId,
  } = props;

  const classNameWrapper = ClassNames(
    "skeleton-loader-wrap",
    {
      "has-width": width,
      "has-height": height,
      "is-blue": isBlue,
    },
    props.className
  );

  return (
    <div
      className={`${classNameWrapper} ${
        wrapperClassName ? wrapperClassName : ""
      }`}
      style={{ height: `${height}`, width: `${width}` }}
      data-testid={dataTestId}
    >
      <div
        className="skeleton-loader"
        style={{ height: `100%`, width: `100%` }}
      />
    </div>
  );
};

export default SkeletonLoader;
